export default __webpack_public_path__ + "static/media/image4.ca344d14.jpg";